import { Component, OnInit, AfterViewInit, Input } from '@angular/core';

@Component({
    selector: 'app-direct-link-timeline',
    templateUrl: './direct-link-timeline.component.html',
    styleUrls: ['./direct-link-timeline.component.scss'],
    standalone: false
})
export class DirectLinkTimelineComponent implements OnInit {


  @Input() stepsItems: any[];
  @Input() completed: boolean;
  @Input() badgeShipmentType;
  @Input() timeZoneDifference: string;
  @Input() sortedStepsItems: any[];


  get isHorizontal(): boolean {
    return this.badgeShipmentType === 5 || this.badgeShipmentType === 11;
  }

  constructor() {
    this.isHorizontal;
  }

  ngOnInit(): void {

  }



  ngAfterViewInit(): void {
    this.adjustTimelineLine();
    window.addEventListener('resize', () => {
      this.adjustTimelineLine();
    });
  }

  adjustTimelineLine() {
    setTimeout(() => {

      const track = document.querySelector('.timeline-track');
      if (!track) return;
      const points = Array.from(document.querySelectorAll('.timeline-point'));
      if (points.length === 0) return;

      const lastPoint = points[points.length - 1];


      const trackRect = track.getBoundingClientRect();
      const lastPointRect = lastPoint.getBoundingClientRect();

      const lineWidth = (lastPointRect.left + (lastPointRect.width / 2)) -
        trackRect.left - 100; // 100px is the left padding


      const timelineTrackBefore = track.querySelector('::before');
      if (timelineTrackBefore) {
        (timelineTrackBefore as HTMLElement).style.width = `${lineWidth}px`;
      } else {
        // If we can't directly access ::before, add a style tag
        const styleTag = document.createElement('style');
        styleTag.innerHTML = `
      .timeline-track::before {
        width: ${lineWidth}px !important;
      }
    `;
        document.head.appendChild(styleTag);
      }
    }, 0);
  }





}
